import {
  Accordion,
  FormControlLabel,
  Grid,
  Switch,
  Button
} from '@material-ui/core';
import { Control, Controller } from "react-hook-form";
import React, { useMemo, useState } from 'react'
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ContentFilterValues from 'src/model/ContentFilter';
import { useIntl } from 'react-intl';
import pageMessages from "../../../messages";
import contentMessages from "../../messages";
import { ContentFilterOptions } from 'src/utils/contentFilterOptions';
import initialContentFilterState from 'src/utils/initialStates/initialContentFilterState';
import useContentFilterStyles from '../styles';
import FilterField from './fields/FilterField';
import FilterAccordionHeader from './FilterAccordionHeader';
import useContentFilterOptions, { AllContentFilterOptions } from 'src/hooks/contentFilters/useContentFilterOptions';
import { getFieldConfigs } from './helper';
import FilterFieldPrice from './fields/FilterFieldPrice';
import Visible from 'src/components/Visibile';
import { SwitchFilterNames } from '../switches/helpers/switchTypes';

function FilterAccordion({ disabled, control, options, getValues, register, reset, handleSwitchTrigger,handleFilterChangeSwitch, onAccordionToggle, preSetValues, onFilterChange }: {
  disabled: boolean;
  control: Control<ContentFilterValues>;
  options: ContentFilterOptions;
  getValues: any;
  reset: any;
  register: any;
  handleSwitchTrigger:( {e, switchName, switchType, onChange, onExtraChange}: {
      e: React.ChangeEvent<HTMLInputElement>,
      switchName: SwitchFilterNames,
      switchType: "multi" | "one_only",
      onChange: (v: any) => void,
      onExtraChange?: (checked: boolean)=>void,
    }) => void;
  handleFilterChangeSwitch: (onChange: (v: any) => void) => (value: any) => void
  onAccordionToggle?: (value: boolean) => void;
  preSetValues: () => void;
  onFilterChange: (filters: ContentFilterValues) => void;

}) {
  const { formatMessage } = useIntl();
  const classes = useContentFilterStyles();

  // Accordion:
  const [expanded, setExpanded] = useState(false);
  const handleAccordionToggle = () => {
    onAccordionToggle && onAccordionToggle(!expanded);
    setExpanded(!expanded);
  };

  const allFilterOptions: AllContentFilterOptions = useContentFilterOptions();
  const fieldConfigs = useMemo(() => getFieldConfigs(options, allFilterOptions), [options, allFilterOptions]);

  const resetFilters = () => {
    const values = getValues();
    onFilterChange(values);
  };

  return (
    <Accordion onChange={handleAccordionToggle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon color="primary" />}>
        <FilterAccordionHeader expanded={expanded} getValues={getValues} />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} direction="row">
          {fieldConfigs.map(
            ({ name, label, options, isVisible }) => (
              <FilterField
                key={name}
                name={name}
                label={formatMessage(label)}
                control={control}
                options={options}
                isVisible={isVisible}
                disabled={disabled}
                formatMessage={formatMessage}
                onChangeWrapper={handleFilterChangeSwitch}
              />
            )
          )}
          <Visible if={options.marketplaceProducts}>
            <FilterFieldPrice
              disabled={disabled}
              control={control}
              register={register}
              preSetValues={preSetValues}
              handleFilterChangeSwitch={handleFilterChangeSwitch}
            />
          </Visible>
          <Grid container>
            <Grid item xs={12} md={6} lg={3} className={classes.gridCenter}>
              {options?.archived && (
                <Controller
                  name={"archived"}
                  control={control}
                  render={({ onChange, value }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={value}
                          onChange={(e) => handleSwitchTrigger({e, switchName: 'archived', switchType:'one_only', onChange})}
                          color="primary"
                          disabled={disabled}
                        />
                      }
                      label={formatMessage(pageMessages.archived)}
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6} lg={9} className={classes.flexEndPaddingR8}>
              <Button
                color="secondary"
                variant="outlined"
                disabled={disabled}
                onClick={() => {
                  reset(initialContentFilterState);
                  resetFilters();
                }}
              >
                {formatMessage(contentMessages.reset_all_filters)}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>)
}

export default FilterAccordion